import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LogOut, FileText, ImageIcon, Mail, LayoutGrid, ExternalLink, Sparkles, BarChart3 } from 'lucide-react';

const AdminShell = ({ children, title, wide = false }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const logout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  const items = [
    { to: '/admin', label: 'Overview', icon: LayoutGrid },
    { to: '/admin/blog', label: 'Blog posts', icon: FileText },
    { to: '/admin/workflows', label: 'AI content workflow', icon: Sparkles },
    { to: '/admin/images', label: 'Images', icon: ImageIcon },
    { to: '/admin/contacts', label: 'Contacts', icon: Mail },
    { to: '/admin/analytics', label: 'Analytics setup', icon: BarChart3 },
  ];

  return (
    <div className="min-h-screen bg-[var(--bg-alt)]">
      <header className="bg-white border-b border-[var(--line-2)]">
        <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Link to="/admin" className="font-semibold text-sm text-ink">BriefingIQ · Admin</Link>
          </div>
          <div className="flex items-center gap-4">
            <Link
              to="/"
              target="_blank"
              rel="noreferrer"
              className="text-xs text-ink-2 hover:text-ink inline-flex items-center gap-1"
            >
              View site <ExternalLink className="w-3 h-3" />
            </Link>
            <button onClick={logout} className="text-xs text-ink-2 hover:text-ink inline-flex items-center gap-1">
              <LogOut className="w-3 h-3" /> Sign out
            </button>
          </div>
        </div>
      </header>
      <div className={`${wide ? 'max-w-7xl' : 'max-w-6xl'} mx-auto px-6 py-10`}>
        <div className={`grid ${wide ? '' : 'lg:grid-cols-[220px,1fr]'} gap-8`}>
          <aside className={wide ? 'hidden' : ''}>
            <nav className="space-y-1">
              {items.map((it) => {
                const Icon = it.icon;
                const active =
                  it.to === '/admin' ? location.pathname === '/admin' : location.pathname.startsWith(it.to);
                return (
                  <Link
                    key={it.to}
                    to={it.to}
                    className={`flex items-center gap-2 text-sm px-3 py-2 rounded-lg transition-colors ${
                      active ? 'bg-white text-ink font-medium border border-[var(--line-2)]' : 'text-ink-2 hover:text-ink'
                    }`}
                  >
                    <Icon className="w-4 h-4" />
                    {it.label}
                  </Link>
                );
              })}
            </nav>
          </aside>
          <main>
            {title && <h1 className="text-2xl font-semibold text-ink tracking-tight mb-6">{title}</h1>}
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default AdminShell;
